import React from "react";

interface SynkSmashProps {
  customUrl?: string;
  file?: File;
  integrationUrl?: string;
}

const SynkSmash: React.FC<SynkSmashProps> = ({
  customUrl,
  file,
  integrationUrl,
}) => {
  // URL directe sans useState ni useEffect
  let url = "https://smash.synk.ws";

  if (customUrl) {
    url = customUrl;
  } else if (integrationUrl) {
    url = integrationUrl;
  }

  // Logs de débogage si en mode dev
  if (process.env.REACT_APP_DEV_MODE === "true") {
    console.log("🔐 SynkSmash - Props reçues:");
    console.log("  - customUrl:", customUrl);
    console.log("  - file:", file);
    console.log("  - integrationUrl:", integrationUrl);
    console.log("  - URL finale:", url);
  }

  return (
    <div className="w-full h-full">
      <iframe
        src={url}
        title="Synk Smash"
        className="w-full h-full border-none"
        sandbox="allow-scripts allow-same-origin allow-popups allow-downloads allow-clipboard-write"
        allow="camera; microphone; fullscreen; clipboard-write"
      />
    </div>
  );
};

export default SynkSmash;
